import { useEffect, useState } from "react";
import {
  getAllHistories,
  getAllTechnicians,
  getTechnicianById,
  showAllTechnician,
} from "../api/technician";

export function useTechnicianListHooks({ filter }) {
  const [technicians, setTechnicians] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getTechnicians = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAllTechnicians({ ...filter });
      setTechnicians(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getTechnicians(filter);
  }, [filter]);

  return {
    technicians,
    meta,
    loading,
    errorMsg,
    getTechnicians,
  };
}

export function useTechnicianHooks({ id }) {
  let [data, setData] = useState({});
  let [success, setSuccess] = useState(null);
  let [fetched, setFetched] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getTechnician(id);
    }
  }, [id]);

  const getTechnician = async (id) => {
    setData({});
    setError("");
    setLoading(true);
    setSuccess(null);
    setFetched(false);
    try {
      let response = await getTechnicianById(id);
      setData(response.data.data);
      setFetched(true);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setError(data.message);
      } else {
        setError("Something Error Happened");
      }
    }

    setLoading(false);
  };

  return {
    data,
    fetched,
    success,
    error,
    loading,
    getTechnician,
  };
}

export function useTechnicianHistoryHooks() {
  const [histories, setHistories] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getHistories = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAllHistories({ ...filter });
      setHistories(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  return {
    histories,
    meta,
    loading,
    errorMsg,
    getHistories,
  };
}

export function useHelperListHooks() {
  const [helpers, setHelpers] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getHelpers = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await showAllTechnician({ ...filter, role: "helper" });
      setHelpers(data.data);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getHelpers();
  }, []);

  return {
    helpers,
    loading,
    errorMsg,
    getHelpers,
  };
}
